import type { ReactElement } from 'react';

import { IconName } from '@/app/components/icons/icon-name';

export const createIconMapping = <T extends IconName>(
  icons: Record<T, ReactElement>
) => icons;
